import { TFunction } from 'i18next'

import { RecurringInvoiceDelivery } from '../enums/recurringInvoiceDelivery'

const deliveryTKeys = {
  [RecurringInvoiceDelivery.Create]: 'recurring_invoices.delivery.option.create',
  [RecurringInvoiceDelivery.CreateAndSend]: 'recurring_invoices.delivery.option.create_and_send',
  [RecurringInvoiceDelivery.CreateDraft]: 'recurring_invoices.delivery.option.create_draft',
}

export const getRecurringInvoiceDeliveryLabel = (delivery: RecurringInvoiceDelivery | undefined, t: TFunction) => {
  return delivery ? t(deliveryTKeys[delivery]) : ''
}
